import React, {useEffect, useState} from 'react';
import {Paciente} from './Paciente';
import {ListaUsu} from './ListaUsu';
import {FormularioPacientes} from './FormularioPacientes';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import Switch from 'react-switch';

export const ContentBodyPacientes = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the `ListaUsuarios` variable to the value of the `ListaUsu()` function. */
	const [ListaUsuarios, setListaUsuarios] = useState(ListaUsu());

	/* Setting the state of the `PantallaPeril` variable to the value of the `false` variable. */
	const [PantallaPeril, setPantallaPerfil] = useState(false);

	/* Setting the state of the `ShareCareCheck` variable to the value of the `true` variable. */
	const [ShareCareCheck, setShareCareCheck] = useState(true);

	/* Setting the state of the `UsuarioFiltro` variable to the value of the `{
            nombre: "",
            telefono: "",
            codPost: "",
        }` object. */
	const [UsuarioFiltro, setUsuarioFiltro] = useState({
		nombre: '',
		telefono: '',
		codPost: '',
	});

	/**
	 * When the input changes, set the UsuarioFiltro state to the current value of the input.
	 */
	const onInputChange = (event) => {
		setUsuarioFiltro({
			...UsuarioFiltro,
			[event.target.name]: event.target.value,
		});
	};

	/* Setting the state of the `ListaUsuarios` variable to the value of the `ListaUsu()` function. */
	useEffect(() => {
		setListaUsuarios(ListaUsu());
	}, []);

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const abrirPerfil = () => {
		setPantallaPerfil(true);
	};

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const anadirUsuarios = () => {
		setPantallaPerfil(true);
	};

	/**
	 * If the ShareCareCheck is true, set it to false. If it's false, set it to true
	 */
	const filtroShareCare = () => {
		if (ShareCareCheck) {
			setShareCareCheck(false);
		} else {
			setShareCareCheck(true);
		}
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={10}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentUsuarios'>
				{PantallaPeril === false ? (
					<div className='derContentUsusaios'>
						<div className='headContentUsuarios'>
							<div className='superiorHeadContentUsuarios'>
								<div>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='40'
										height='40'
										fill='currentColor'
										className='bi bi-person-video2'
										viewBox='0 0 16 16'
									>
										<path d='M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
										<path d='M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2ZM1 3a1 1 0 0 1 1-1h2v2H1V3Zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5Zm-4-2h3v2H2a1 1 0 0 1-1-1v-1Zm3-1H1V8h3v2Zm0-3H1V5h3v2Z' />
									</svg>
								</div>
								<div className='centrador titleHeadHistorialFacturas'>
									Tus pacientes
								</div>
							</div>
							<div className='separador'></div>
							<div className='inferiorHeadContentUsuarios'>
								<div className='derHeadContentUsuarios'>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>Nombre</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='nombre'
												type='text'
												value={UsuarioFiltro.nombre}
												onChange={onInputChange}
											/>
										</div>
									</div>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>Teléfono</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='telefono'
												type='text'
												value={UsuarioFiltro.telefono}
												onChange={onInputChange}
											/>
										</div>
									</div>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>Código postal</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='codPost'
												type='text'
												value={UsuarioFiltro.codPost}
												onChange={onInputChange}
											/>
										</div>
									</div>
									{/* <div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>ShareCare</div>
										<div className='inputUsuario'>
											<div className='centrador'>
												<div className='switchShareCare centrador'>
													<Switch
														onChange={filtroShareCare}
														checked={ShareCareCheck}
														onColor='#23C290'
														uncheckedIcon={false}
													/>
												</div>
											</div>
										</div>
									</div> */}
								</div>
								<div className='izqheadContentUsuarios centrador'>
									<div
										className='buttonAddUsuarios'
										onClick={anadirUsuarios}
									>
										<div className='centrador'>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='16'
												height='16'
												fill='currentColor'
												className='bi bi-plus-circle-fill'
												viewBox='0 0 16 16'
											>
												<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
											</svg>
										</div>
										<div className='centrador'>Añadir paciente</div>
									</div>
								</div>
							</div>
						</div>
						<div className='listaPaciente'>
							{ListaUsuarios.map((usuario, id) =>
								usuario.nombreUsuario
									.toLowerCase()
									.includes(UsuarioFiltro.nombre.toLowerCase()) &&
								usuario.telefonoUsuario.includes(UsuarioFiltro.telefono) &&
								usuario.codPostUsuario.includes(UsuarioFiltro.codPost) &&
								((ShareCareCheck === true && usuario.ShareCare === 'Activo') ||
									ShareCareCheck === false) ? (
									<Paciente
										key={id}
										fotPantallaPerileccionUsuario={usuario.direccionUsuario}
										nombreUsuario={usuario.nombreUsuario}
										idUsuario={usuario.idUsuario}
										direccionUsuario={usuario.direccionUsuario}
										telefonoUsuario={usuario.telefonoUsuario}
										codPostUsuario={usuario.codPostUsuario}
										ShareCare={usuario.ShareCare}
										abrirPerfil={abrirPerfil}
									/>
								) : null
							)}
						</div>
					</div>
				) : (
					<FormularioPacientes setPantallaPerfil={setPantallaPerfil} />
				)}
			</div>
		</>
	);
};
/*


usuarios:
    info tarjetas:
        - nombre correo telefono 
    form :
        - contrase correo ... ( lo que hay en mi perfil )

pacientes:
    info tarjeta: 
        - nombre y apellidos
        - direcion
        - localicadad
        - cod postal
        - telefono corroceo
        - sharecare
    form:
        - numero cuenta
cuidadore: 
    info:
        - nombre, apellido localidad, telfono, estado si esta trabajando   
    form :
        - ratio
*/
